import React, { useMemo } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Amount from 'design-system/Amount';
import { TextButton } from 'design-system/TextButton';
import { formatPlural } from 'utils';
import useStyles from 'hooks/useStyles';
import styleSet from 'features/feed/components/search/styles';
const TotalAmountRow = ({ currency, isEditing, totalAmount, isAllSelected, onSelectUnselectAll, numberOfTransactions, }) => {
    const styles = useStyles(styleSet);
    const RightContent = useMemo(() => {
        if (isEditing) {
            return <TextButton text={isAllSelected ? 'Deselect all' : 'Select all'} onPress={onSelectUnselectAll}/>;
        }
        return totalAmount > 0 ? (<Amount Blue Numbers-16 value={{ value: totalAmount, currency }} showSign/>) : (<Amount OffBlack Numbers-16 value={{ value: totalAmount, currency }} showSign/>);
    }, [currency, isAllSelected, isEditing, onSelectUnselectAll, totalAmount]);
    if (!numberOfTransactions) {
        return null;
    }
    return (<View style={[styles.searchHeaderRow, styles.totalSpentContainer]}>
      <Text Text-16 Gray>
        {numberOfTransactions} {formatPlural('transaction', 'transactions', numberOfTransactions)}
      </Text>
      {RightContent}
    </View>);
};
export default TotalAmountRow;
